<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="1060px">
      <v-form ref="form" v-model="valid">
        <v-layout row wrap>
          <v-flex sm8 md8>
            <!-- <v-alert
							:value="true"
							type="warning"
							v-if="user && user.customer_id && user.signedcontract_at"
						>
							Atenção: Esse usuário já assinou a Enercred
						</v-alert> -->
            <v-card>
              <v-card-title>
                <span class="headline"
                  >{{
                    user && user.customer_id ? "Editar" : "Cadastrar"
                  }}
                  Cliente</span
                >
                <v-spacer />
                <span style="padding-right: 10px">{{
                  user ? user.customer_id : ""
                }}</span>
              </v-card-title>
              <v-card-text>
                <v-alert
                  v-if="user && user.customer_id && user.signedcontract_at"
                  :value="true"
                  type="warning"
                >
                  <p v-html="assinou" />
                </v-alert>
                <v-alert v-if="cpf_duplicated" :value="true" type="warning">
                  <p v-html="cpf_duplicated_msg" />
                </v-alert>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        label="Nome Completo"
                        v-model="name"
                        type="text"
                        required
                        :hint="nome_titular"
                        :rules="[
                          (v) => !!v || 'Por favor, informe o seu nome',
                          (v) =>
                            v.length >= 10 ||
                            'Por favor, preencha o nome completo.',
                        ]"
                      ></v-text-field>
                      <input
                        type="hidden"
                        name="nome_titular"
                        v-model="nome_titular"
                      />
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        label="E-mail"
                        v-model="email"
                        read-only
                        hint="E-mail principal do membro"
                        :rules="[
                          (v) => !!v || 'Por favor, informe o email',
                          (v) =>
                            /^(([^<>()\[\]\\.,;:\s@&quot;]+(\.[^<>()\[\]\\.,;:\s@&quot;]+)*)|(&quot;.+&quot;))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/.test(
                              v,
                            ) || 'E-mail precisa ser válido',
                        ]"
                        name="email"
                        :disabled="user.customer_id ? true : false"
                        type="email"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-text-field
                        type="tel"
                        v-model="phone"
                        :rules="[
                          (v) => !!v || 'Por favor, informe o celular',
                          (v) =>
                            v.length > 10 ||
                            'Ops. Parece que esse não é um número de telefone',
                        ]"
                        prepend-icon="phone"
                        return-masked-value
                        mask="(##)#####-####"
                        label="Telefone"
                        hint="Preferencialmente um telefone com whatsapp"
                        persistent-hint
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md1 pt-2>
                      <v-icon @click="dialog_calculator = true" pt-2
                        >calculate</v-icon
                      >
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        id="cpf"
                        v-model="cpf"
                        autofocus
                        label="CPF/CNPJ"
                        mask="###.###.###-##"
                        append-icon="launch"
                        @click:append="show_dialog_ucs"
                        @click:append-outer="
                          buscaDadosComplementares(cpf, false)
                        "
                        append-outer-icon="autorenew"
                        :rules="[
                          (v) => !!v || 'Por favor, informe seu CPF!',
                          (v) => v.length >= 11 || 'Preencha o CPF Completo',
                          (v) =>
                            this.validaCPF(this.cpf) === true || 'CPF inválido',
                          // v => this.validaCPFNaBase(this.cpf).value === true || 'CPF já existe na base'
                        ]"
                        required
                        @change="buscaDadosComplementares($event, true)"
                      ></v-text-field>
                    </v-flex>
                    <!-- <v-flex xs12 sm6 md1>
											<v-progress-circular
												v-if="loading_cpf"
												indeterminate
												color="primary"
											></v-progress-circular>
										</v-flex> -->
                    <v-flex xs12 sm6 md2>
                      <v-text-field
                        id="rg"
                        v-model="rg"
                        label="Documento"
                        hint="RG ou outro oficial"
                        :rules="[
                          (v) => !!v || 'Por favor, informe o documento',
                          (v) =>
                            v.length > 7 ||
                            'Ops. Parece que esse não é um número valido',
                        ]"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md2>
                      <v-text-field
                        id="orgao_expeditor"
                        v-model="orgao_expeditor"
                        label="Orgão Expeditor"
                        hint="ex. SSP/MG"
                        :rules="[
                          (v) =>
                            !!v ||
                            'Por favor, informe o orgao expeditor do documento',
                        ]"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-text-field
                        label="Data de Nasc"
                        v-model="birthday"
                        required
                        mask="##/##/####"
                        :rules="[
                          (v) =>
                            !!v || 'Por favor, informe a data de nascimento',
                          (v) =>
                            v.length > 9 ||
                            'Ops. Parece que esse não é um data valida',
                        ]"
                        return-masked-value
                      ></v-text-field>
                    </v-flex>
                    <!-- <v-flex  xs12 sm6 md4>
											<v-text-field label="Password*" type="password" required></v-text-field>
										</v-flex> -->
                    <v-flex xs12 sm6 md1>
                      <v-select
                        :items="['M', 'F']"
                        label="Sexo"
                        v-model="gender"
                        :rules="[(v) => !!v || 'Por favor, informe o sexo']"
                        required
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <!-- <v-autocomplete
												:items="profissoes.profissoes"
												label="Profissao"
												v-model="profissao"
												:rules='[
													v => !!v || "Por favor, informe a profissão ou escolha \"outra\"",
												]'
											></v-autocomplete> -->
                      <v-text-field
                        label="Profissao"
                        v-model="profissao"
                        type="text"
                        required
                        :rules="[
                          (v) => !!v || 'Por favor, informe a profissão',
                        ]"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-autocomplete
                        :items="marital_status"
                        item-value="value"
                        item-text="text"
                        label="Estado Civil"
                        v-model.lazy="marital_status_value"
                        :rules="[
                          (v) => !!v || 'Por favor, selecione o estado civil!',
                        ]"
                        hint="'Selecione o estado civil'"
                        required
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-autocomplete
                        v-if="marital_status_value === 'Casado(a)'"
                        :items="marital_type"
                        item-text="text"
                        item-value="value"
                        label="Regime de Bens"
                        v-model.lazy="marital_type_value"
                        :rules="[
                          (v) =>
                            !!v || 'Por favor, selecione o regime de bens!',
                        ]"
                        hint="Selecione o regime de bens"
                        :disable="marital_status_value !== 'Casado(a)'"
                        required
                      ></v-autocomplete>
                      <!-- <div v-else>N/A</div> -->
                    </v-flex>
                    <v-flex xs12 sm6 md2>
                      <v-text-field
                        id="cep"
                        v-model="cep"
                        label="CEP"
                        mask="#####-###"
                        :rules="[
                          (v) => !!v || 'Por favor, informe o CEP do membro',
                          (v) =>
                            v.length > 7 ||
                            'Ops. Parece que esse não é um CEP válido',
                        ]"
                        @change="buscaCep($event)"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md1>
                      <v-progress-circular
                        v-if="loading_cep"
                        indeterminate
                        color="primary"
                      ></v-progress-circular>
                    </v-flex>
                    <v-flex xs12 sm6 md5>
                      <v-text-field
                        id="logradouro"
                        v-model="logradouro"
                        label="Logradouro"
                        hint="opcional"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md2>
                      <v-text-field
                        id="numero"
                        v-model="numero"
                        label="Núm."
                        hint="opcional"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md2>
                      <v-text-field
                        id="complemento"
                        v-model="complemento"
                        label="Complemento"
                        hint="opcional"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-text-field
                        id="bairro"
                        v-model="bairro"
                        label="Bairro"
                        hint="opcional"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-text-field
                        id="localidade"
                        v-model="localidade"
                        label="Cidade"
                        hint="opcional"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-autocomplete
                        :items="states"
                        item-text="name"
                        item-value="initials"
                        label="Estado"
                        prepend-icon="map"
                        v-model="state"
                        return-object
                        :rules="[
                          (v) => !!v || 'Por favor, selecione o seu estado!',
                        ]"
                        hint="Selecione o estado"
                        required
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-select
                        :items="payment_type_items"
                        item-value="value"
                        item-text="text"
                        label="Metodo de Pagamento*"
                        v-model="payment_type"
                        :rules="[
                          (v) =>
                            !!v || 'Por favor, informe o método de pagamento',
                        ]"
                        required
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <!-- <v-text-field
												id="consumer_unit"
												v-model="consumer_unit"
												label="Numero de Instalação CEMIG"
												hint="opcional"
											></v-text-field> -->

                      <v-combobox
                        v-model="ucs"
                        :filter="filter"
                        :hide-no-data="!search"
                        :items="items"
                        :search-input.sync="search"
                        hide-selected
                        label="Número(s) de Instalação(s) CEMIG"
                        multiple
                        small-chips
                        solo
                      >
                        <template v-slot:no-data>
                          <v-list-tile>
                            <span class="subheading">[Enter] Criar</span>
                            <v-chip
                              :color="`${colors_uc[nonce - 1]} lighten-3`"
                              label
                              small
                            >
                              {{ search }}
                            </v-chip>
                          </v-list-tile>
                        </template>
                        <template v-slot:selection="{ item, parent, selected }">
                          <v-chip
                            v-if="item === Object(item)"
                            :color="`${item.color} lighten-3`"
                            :selected="selected"
                            label
                            small
                          >
                            <span class="pr-2">
                              {{ item.text }}
                            </span>
                            <v-icon small @click="parent.selectItem(item)"
                              >close</v-icon
                            >
                          </v-chip>
                        </template>
                        <template v-slot:item="{ index, item }">
                          <v-list-tile-content>
                            <v-text-field
                              v-if="editing === item"
                              v-model="editing.text"
                              autofocus
                              flat
                              background-color="transparent"
                              hide-details
                              solo
                              @keyup.enter="edit(index, item)"
                            ></v-text-field>
                            <v-chip
                              v-else
                              :color="`${item.color} lighten-3`"
                              dark
                              label
                              small
                            >
                              {{ item.text }}
                            </v-chip>
                          </v-list-tile-content>
                          <v-spacer></v-spacer>
                          <v-list-tile-action @click.stop>
                            <v-btn icon @click.stop.prevent="edit(index, item)">
                              <v-icon>{{
                                editing !== item ? "edit" : "check"
                              }}</v-icon>
                            </v-btn>
                          </v-list-tile-action>
                        </template>
                      </v-combobox>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-textarea
                        v-model="sales_observation"
                        label="Observação"
                        placeholder="Escreva uma observação que desejar sobre a venda e contato realizado..."
                      ></v-textarea>
                    </v-flex>
                  </v-layout>
                </v-container>
                <!-- <small>*indicates required field</small> -->
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click="dialog = false"
                  >fechar</v-btn
                >
                <v-btn
                  color="green darken-1"
                  :loading="loading"
                  :disabled="loading"
                  @click.prevent="save"
                  >Salvar</v-btn
                >
                <v-btn
                  color="blue darken-1"
                  :loading="loading"
                  :disabled="!valid || loading"
                  @click.prevent="validate"
                  type="submit"
                  >Vender</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-flex>
          <v-flex sm4 lg4 xs4>
            <v-card color="green" height="99%">
              <v-card-title class="pb-1">
                <span class="headline">Processo e Dicas</span>
              </v-card-title>
              <v-card-text class="pt-0">
                <v-alert v-if="!cemig_status" type="warning" value="true">
                  <p>
                    Atenção: O site da CEMIG está com instabilidade, valide com
                    atenção os dados do membro.
                  </p>
                </v-alert>
                <br />
                <small class="pb-2">
                  Estamos regulamentados pela ANEEL na Resolução Normativa
                  482/2012 na modalidade de geração compartilhada (RN 687/2015),
                  podendo assim dividir entre seus cooperados os créditos de
                  energia gerados por uma usina de energia renovável.
                </small>
                <!-- <v-divider color="white"/><br> -->
                <v-list subheader two-line class="pt-1">
                  <v-list-tile>
                    <v-list-tile-action>
                      <v-checkbox
                        v-model="processo_vendas.cordialidade"
                      ></v-checkbox>
                    </v-list-tile-action>

                    <v-list-tile-content
                      @click="
                        processo_vendas.cordialidade =
                          !processo_vendas.cordialidade
                      "
                    >
                      <v-list-tile-title
                        >Apresentação/ Abordagem</v-list-tile-title
                      >
                      <v-list-tile-sub-title two-line
                        >De aquele “bom dia”
                        inesquecível.</v-list-tile-sub-title
                      >
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile>
                    <v-list-tile-action>
                      <v-checkbox
                        v-model="processo_vendas.produto"
                      ></v-checkbox>
                    </v-list-tile-action>

                    <v-list-tile-content
                      @click="
                        processo_vendas.produto = !processo_vendas.produto
                      "
                    >
                      <v-list-tile-title>Sobre a Enercred</v-list-tile-title>
                      <v-list-tile-sub-title two-line
                        >Energia Limpa e Sustentabilidade</v-list-tile-sub-title
                      >
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile>
                    <v-list-tile-action>
                      <v-checkbox
                        v-model="processo_vendas.titularidade"
                      ></v-checkbox>
                    </v-list-tile-action>

                    <v-list-tile-content
                      @click="
                        processo_vendas.titularidade =
                          !processo_vendas.titularidade
                      "
                    >
                      <v-list-tile-title
                        >Problema / Oportunidade</v-list-tile-title
                      >
                      <v-list-tile-sub-title
                        >Maior ênfase ao direito de
                        escolha</v-list-tile-sub-title
                      >
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-action>
                      <v-checkbox v-model="processo_vendas.coleta"></v-checkbox>
                    </v-list-tile-action>

                    <v-list-tile-content
                      @click="processo_vendas.coleta = !processo_vendas.coleta"
                    >
                      <v-list-tile-title>Coleta de dados</v-list-tile-title>
                      <v-list-tile-sub-title
                        >Garanta que é o titular da conta</v-list-tile-sub-title
                      >
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-action>
                      <v-checkbox
                        v-model="processo_vendas.duasfaturas"
                      ></v-checkbox>
                    </v-list-tile-action>

                    <v-list-tile-content
                      @click="
                        processo_vendas.duasfaturas =
                          !processo_vendas.duasfaturas
                      "
                    >
                      <v-list-tile-title
                        >Explicação sobre 2 faturas</v-list-tile-title
                      >
                      <v-list-tile-sub-title
                        >Fatura Cemig + Fatura Energia
                        Limpa</v-list-tile-sub-title
                      >
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile @click="dialog_venda = true">
                    <v-list-tile-action>
                      <v-checkbox
                        v-model="processo_vendas.condicoes"
                      ></v-checkbox>
                    </v-list-tile-action>

                    <v-list-tile-content
                      @click="
                        processo_vendas.condicoes = !processo_vendas.condicoes
                      "
                    >
                      <v-list-tile-title
                        >Leitura das Condições</v-list-tile-title
                      >
                      <v-list-tile-sub-title
                        >O membro precisa aceitar. Dizer
                        sim.</v-list-tile-sub-title
                      >
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-action>
                      <v-checkbox
                        v-model="processo_vendas.campanhas"
                      ></v-checkbox>
                    </v-list-tile-action>

                    <v-list-tile-content
                      @click="
                        processo_vendas.campanhas = !processo_vendas.campanhas
                      "
                    >
                      <v-list-tile-title>Campanha vigente</v-list-tile-title>
                      <v-list-tile-sub-title
                        >Explique as campanhas vigentes</v-list-tile-sub-title
                      >
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile @click="dialog_app = true">
                    <v-list-tile-action>
                      <v-checkbox
                        v-model="processo_vendas.indicacao"
                      ></v-checkbox>
                    </v-list-tile-action>

                    <v-list-tile-content
                      @click="
                        processo_vendas.indicacao = !processo_vendas.indicacao
                      "
                    >
                      <v-list-tile-title>
                        Indicação de amigo / download do App</v-list-tile-title
                      >
                      <v-list-tile-sub-title
                        >Explique as campanhas vigentes</v-list-tile-sub-title
                      >
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-card-text>
            </v-card>
            <v-divider />
          </v-flex>
        </v-layout>
        <v-snackbar
          :color="color"
          :bottom="bottom"
          :top="top"
          :left="left"
          :right="right"
          multi-line
          v-model="snackbar"
          dark
        >
          <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
          <div v-html="snackMessage"></div>
          <v-icon size="16" @click="snackbar = false">
            mdi-close-circle
          </v-icon>
        </v-snackbar>
      </v-form>
    </v-dialog>
    <v-dialog v-model="dialog_ucs" persistent max-width="500px">
      <v-card>
        <v-card-title> Unidades Consumidoras do Cliente na Cemig </v-card-title>
        <v-card-text>
          <v-list subheader three-line>
            <v-subheader
              >Selecione as unidades consumidoras que o membro quer
              contratar.</v-subheader
            >
            <v-list-tile
              v-for="(uc, idx) in ucs_cemig"
              v-bind:key="uc.installation_number"
            >
              <v-list-tile-action>
                <v-checkbox
                  v-model="ucs_chbox"
                  :value="uc.installation_number"
                  :color="colors_uc[idx]"
                ></v-checkbox>
              </v-list-tile-action>

              <v-list-tile-content>
                <v-list-tile-title>{{
                  uc.installation_number
                }}</v-list-tile-title>
                <v-list-tile-sub-title>{{ uc.address }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="dialog_ucs = false"
            >fechar</v-btn
          >
          <v-btn color="blue darken-1" @click="ucs_selected()"
            >Selecionar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_cpf" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          {{ label_loading_cpf }}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_venda" persistent max-width="500px">
      <v-card>
        <v-card-title> Ao aceitar o termo você concorda em: </v-card-title>
        <v-card-text>
          <v-list subheader three-line>
            <!-- <v-subheader>Ao aceitar o termo você concorda em:</v-subheader> -->
            <v-list-tile>
              <v-list-tile-content>
                1. Receber um percentual dos créditos gerados de acordo com seu
                consumo médio.
              </v-list-tile-content>
            </v-list-tile>
            <v-divider />
            <v-list-tile>
              <v-list-tile-content>
                2. Que é o titular da conta de luz ou possui declaração legal
                para representá-lo.
              </v-list-tile-content>
            </v-list-tile>
            <v-divider />
            <v-list-tile>
              <v-list-tile-content>
                3. Está ciente de que é necessário o aviso prévio de 90 dias
                para cancelamento da assinatura.
              </v-list-tile-content>
            </v-list-tile>
            <v-divider />
            <v-list-tile>
              <v-list-tile-content>
                4. Receberá 10% de desconto sobre os créditos recebidos em
                relação a tarifa vigente pela concessionária local.
              </v-list-tile-content>
            </v-list-tile>
            <v-divider />
            <v-list-tile>
              <v-list-tile-content>
                5. Esta ciente que somente receberá cobrança após os créditos
                chegarem em sua conta de energia.
              </v-list-tile-content>
            </v-list-tile>
            <v-divider />
            <v-list-tile>
              <v-list-tile-content>
                6. Realizará o pagamento pelos créditos recebidos dentro do
                prazo. Caso isso não ocorrá poderá ter seu nome adicionado aos
                sistemas de crédito.
              </v-list-tile-content>
            </v-list-tile>
            <v-divider />
            <v-list-tile>
              <v-list-tile-content>
                7. Permite que o representante legal da cooperativa faça a
                inscrição em seu nome junto a CEMIG.
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="dialog_venda = false"
            >fechar</v-btn
          >
          <!-- <v-btn color="blue darken-1" @click="ucs_selected()">Selecionar</v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_app" persistent max-width="500px">
      <v-card>
        <v-container fluid grid-list-lg>
          <v-card-title> Baixe nosso App </v-card-title>
          <v-card-text>
            <v-list subheader two-line>
              <!-- <v-subheader>Ao aceitar o termo você concorda em:</v-subheader> -->
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-sub-title>
                    <v-text-field
                      width="100%"
                      readonly
                      id="applestore"
                      v-model="applestore"
                      label="Apple Store"
                      value="https://apps.apple.com/br/app/enercred/id1465641135"
                    ></v-text-field>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn
                    icon
                    color="blue"
                    @click.prevent="copyURL('applestore')"
                  >
                    <v-icon>content_copy</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
              <v-divider />
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-sub-title>
                    <v-text-field
                      readonly
                      id="googleplay"
                      v-model="googleplay"
                      label="Google Play"
                      value="https://play.google.com/store/apps/details?id=com.enecred.enercredapp&hl=pt_BR"
                    ></v-text-field>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn
                    icon
                    color="blue"
                    @click.prevent="copyURL('googleplay')"
                  >
                    <v-icon>content_copy</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="dialog_app = false"
              >fechar</v-btn
            >
            <!-- <v-btn color="blue darken-1" @click="ucs_selected()">Selecionar</v-btn> -->
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_calculator" persistent max-width="450px">
      <v-card color="#FFF">
        <Calculator :average="lead.average_consumption || 0" />
        <v-layout pa-2>
          <v-spacer />
          <v-btn dark color="blue" @click="dialog_calculator = false"
            >Fechar</v-btn
          >
        </v-layout>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { eventBus } from "../../main";
import lista_profissoes from "../../utils/profissoes.json";
import statesfile from "@/model/state";
import { getCEP } from "../../services/getCep";
import { getPEOPLE } from "../../services/getPeople";
import { getCPFCemig } from "../../services/getCPFCemig";
import { storeCustomer } from "../../services/users";
import { updateLead, addLead } from "../../services/leads";
import { saveAnalytics } from "../../services/save_analytics";
import { setFbEvent } from "../../services/facebookOfflineEvents";
import { SET_CONVERSION } from "../../graphql/rdstation";
import Calculator from "../../components/sales/Calculator";
import moment from "moment";
import firestore from "@/firebase/firestore";
import { mapGetters } from "vuex";

export default {
  data: function () {
    return {
      dialog: false,
      cpf_duplicated: false,
      cpf_duplicated_msg: "",
      dialog_ucs: false,
      dialog_cpf: false,
      dialog_venda: false,
      dialog_app: false,
      dialog_calculator: false,
      label_loading_cpf: "Validando CPF informado",
      ucs_chbox: [],
      valid: false,
      profissoes: lista_profissoes,
      lead: {},
      cadLead: "new",
      name: "",
      nome_titular: "",
      phone: "",
      email: "",
      average: "",
      cpf: "",
      old_cpf: "",
      rg: "",
      birthday: "",
      mother_name: "",
      orgao_expeditor: "",
      user: {},
      marital_status: [
        { text: "Solteiro(a)", value: "Solteiro(a)" },
        { text: "Casado(a)", value: "Casado(a)" },
        { text: "Separado(a)", value: "Separado(a)" },
        { text: "Divorciado(a)", value: "Divorciado(a)" },
        { text: "Viúvo(a)", value: "Viúvo(a)" },
      ],
      marital_status_value: "",
      marital_type: [
        { text: "Comunhão Universal de Bens", value: "Universal de bens" },
        { text: "Comunhão Parcial de Bens", value: "Parcial de bens" },
        { text: "Separação Total de Bens", value: "Separação total" },
        {
          text: "Participação Final nos Aquestos",
          value: "Final nos aquestos",
        },
      ],
      marital_type_value: "",
      gender: "",
      cemig_status: true,
      cep: "",
      logradouro: "",
      numero: "",
      complemento: "",
      bairro: "",
      localidade: "",
      uf: "",
      state: {
        initials: "MG",
        name: "Minas Gerais",
      },
      profissao: "",
      consumer_unit: "",
      states: statesfile.estados,
      payment_type_items: [
        { text: "Cartão de Crédito", value: "credit_card" },
        { text: "Boleto", value: "boleto" },
        { text: "Pix", value: "pix" },
      ],
      payment_type: "",
      sales_observation: "",
      loading: false,
      loading_cpf: false,
      loading_cep: false,
      color: null,

      colors: ["purple", "info", "success", "warning", "error"],
      top: true,
      bottom: false,
      left: false,
      right: false,
      snackMessage: "",
      snackbar: false,
      //Unidades Consumidoras
      activator: null,
      attach: null,
      colors_uc: ["green", "purple", "indigo", "cyan", "teal", "orange"],
      editing: null,
      index: -1,
      items: [
        { header: "Selecione um opção ou adicione um núm. de instalação" },
      ],
      nonce: 1,
      menu: false,
      ucs: [],
      applestore: "https://apps.apple.com/br/app/enercred/id1465641135",
      googleplay:
        "https://play.google.com/store/apps/details?id=com.enecred.enercredapp&hl=pt_BR",
      processo_vendas: {
        cordialidade: true,
        produto: false,
        titularidade: false,
        venda: false,
        condicoes: false,
        duasfaturas: false,
      },
      ucs_cemig: [
        // {
        // 	address: '',
        // 	installation_number: '',
        // 	name: ''
        // }
        // {
        // 	"address": "TRA EVA RODRIGUES 20 AP 101 BL 2 AGUAS CLARAS 30673-144 BELO HORIZONTE, MG",
        // 	"installation_number": "3007069160",
        // 	"name": "ONESIO FERREIRA DE SOUZA"
        // },
        // {
        // 	"address": "RUA ANTONIO CARLOS 103 CS BAGUARI 35105-000 GOVERNADOR VALADARES, MG",
        // 	"installation_number": "3000437278",
        // 	"name": "ONESIO FERREIRA DE SOUZA"
        // }
      ],
      uc: {},
      x: 0,
      search: null,
      y: 0,
    };
  },
  components: {
    Calculator,
  },
  created() {
    // console.log('created createCustomer')
    var vm = this;
    eventBus.$on("dialog", function (value) {
      // console.log('value: ', value)
      vm.dialog = value;
    });
    // this.lead = {}
    // this.user = {}
    // firestore.collections('config').doc('cemig_status').get()
    // 	.then(cemig_status => {
    // 		this.cemig_status = cemig_status.data().online
    // 	})
    // 	.catch(err => {
    // 		console.error(err)
    // 	})
    // console.log('this.loggedUser: ', this.loggedUser)
  },
  // beforeDestroy(){
  // 	console.log('beforeDestroy')
  // },
  // destroyed(){
  // 	console.log('destroyed')
  // },
  computed: {
    ...mapGetters(["loggedUser"]),
    assinou() {
      if (this.user && this.user.signedcontract_at) {
        let dt_assin = moment(this.user.signedcontract_at).format(
          "DD/MM/YYYY HH:mm",
        );
        let msg =
          "Atenção: Cliente assinou o contrato em <b>" +
          dt_assin +
          "</b> por meio ";
        if (this.user.signedcontract_by === "SUPER") {
          msg =
            msg +
            "de <b>Callcenter</b> - Vendido por: <b>" +
            this.user.signedcontract_partner +
            "</b>";
        } else {
          msg = msg + "<b>Online</b>";
        }
        if (this.user.status) {
          msg =
            msg + "<br> Cliente com status: <b>" + this.user.status + "</b>";
        }
        return msg;
      } else {
        return "";
      }
    },
  },
  mounted() {
    eventBus.$on("Lead", (lead) => {
      // console.log('mounted createCustomer')
      this.lead = {};
      this.user = {};
      this.loading = true;
      if (lead) {
        this.lead = lead;
        this.cadLead = "edit";
        if (lead.user) {
          this.user = lead.user;
          this.name = lead.user.name;
          this.email = lead.user.email;
          this.phone = lead.user.phone.split("+55")[1];
          this.average = lead.user.average_consumption;
          this.cep = lead.user.postal_code;
          this.cpf = lead.user.cpf;
          this.old_cpf = this.cpf;
          if (lead.user.ID_document) {
            let rg = lead.user.ID_document.split("-")[0];
            let org = lead.user.ID_document.split("-")[1];
            this.rg = rg;
            this.orgao_expeditor = org;
          }
          this.birthday = this.reverseDate(lead.user.date_of_birth);
          this.gender = lead.user.gender;
          this.profissao = lead.user.profession;
          this.marital_type_value = lead.user.marital_type;
          this.marital_status_value = lead.user.marital_status;
          this.consumer_unit = lead.user.installation_number;
          this.mother_name = lead.user.mother_name || "";
          if (lead.user.address) {
            this.cep = lead.user.address.postal_code;
            this.logradouro = lead.user.address.address;
            this.numero = lead.user.address.address_number;
            this.complemento = lead.user.address.address_complement;
            this.bairro = lead.user.address.district;
            this.localidade = lead.user.address.city;
            this.state = lead.user.address.state;
          }
          this.installation_numbers = lead.user.installation_numbers || [];
          this.ucs = this.installation_numbers;
          this.items = lead.user.installation_numbers || [];
          this.payment_type = lead.user.payment_type;
          this.sales_observation =
            lead.user.sales_observation || lead.sales_observation;
        } else {
          this.user = {};
          this.clearUser();
          if (lead.name) {
            this.name = lead.name;
            this.email = lead.email;
            this.phone = lead.phone;
            this.average = lead.average_consumption;
            this.cep = lead.postal_code;
            this.cpf = lead.cpf || "";
            this.old_cpf = this.cpf || "";
            if (lead.ID_document) {
              let rg = lead.ID_document.split("-")[0];
              let org = lead.ID_document.split("-")[1];
              this.rg = rg;
              this.orgao_expeditor = org;
            }
            this.birthday = this.reverseDate(lead.date_of_birth) || "";
            this.gender = lead.gender || "";
            this.profissao = lead.profession || "";
            this.marital_type_value = lead.marital_type || "";
            this.marital_status_value = lead.marital_status || "";
            this.consumer_unit = lead.installation_number || "";
            this.mother_name = lead.mother_name || "";
            if (lead.address) {
              this.cep = lead.address.postal_code;
              this.logradouro = lead.address.address;
              this.numero = lead.address.address_number;
              this.complemento = lead.address.address_complement;
              this.bairro = lead.address.district;
              this.localidade = lead.address.city;
              this.state = lead.address.state;
            }
            this.installation_numbers = lead.installation_numbers || [];
            this.ucs = lead.installation_numbers || [];
            this.items = lead.installation_numbers || [];
            this.payment_type = lead.payment_type || "";
            this.sales_observation = lead.sales_observation;
          }
        }
      } else {
        this.clearUser();
      }
      this.loading = false;
    });
  },
  watch: {
    ucs(val, prev) {
      if (val.length === prev.length) return;

      this.ucs = val.map((v) => {
        if (typeof v === "string") {
          v = {
            text: v,
            color: this.colors[this.nonce - 1],
          };

          this.items.push(v);

          this.nonce++;
        }

        return v;
      });
    },
  },
  methods: {
    copyURL(element) {
      var Url =
        document.getElementById(
          element,
        ); /*GET vuejs el reference here (via $ref) but how?*/
      // Url.innerHTML = window.location.href;
      Url.innerHTML = Url.value;
      // console.log(Url.value)
      Url.select();
      document.execCommand("copy");
      alert("Copiado com sucesso.");
    },
    edit(index, item) {
      if (!this.editing) {
        this.editing = item;
        this.index = index;
      } else {
        this.editing = null;
        this.index = -1;
      }
    },
    filter(item, queryText, itemText) {
      if (item.header) return false;

      const hasValue = (val) => (val != null ? val : "");

      const text = hasValue(itemText);
      const query = hasValue(queryText);

      return (
        text.toString().toLowerCase().indexOf(query.toString().toLowerCase()) >
        -1
      );
    },
    buscaCep(cep) {
      if (cep && cep !== "") {
        this.loading_cep = true;
        getCEP(cep)
          .then((result) => {
            // console.log(result)
            ((this.logradouro = result.data.logradouro),
              (this.numero = result.data.numero));
            this.complemento = result.data.complemento;
            this.bairro = result.data.bairro;
            this.localidade = result.data.localidade;
            this.uf = result.data.UF;
            this.loading_cep = false;
            // this.snack('OK: ' + error, 'red', 'top')
          })
          .catch((error) => {
            this.snack(
              "Erro ao buscar o CEP informado. Erro: " + error,
              "red",
              top,
            );
            this.loading_cep = false;
          });
      }
    },
    show_dialog_ucs() {
      this.dialog_ucs = true;
    },
    async buscaDadosComplementares(cpf, validaDuplicate) {
      // console.log('busca Dados Complementares na Cemig para o CPF: ', cpf)
      this.dialog_cpf = true;
      this.label_loading_cpf = "Verificando se CPF já está cadastrado...";
      const cpfExists = await this.validaCPFNaBase(cpf);
      // console.log('cpfExists: ', cpfExists)
      if (validaDuplicate && cpfExists) {
        if (this.cadLead !== "edit") {
          this.valid = false;
        }
        this.dialog_cpf = false;
        return;
        // console.log(this.$refs.form.)
      } else {
        if (cpf && cpf !== "" && this.validaCPF(cpf)) {
          // this.loading_cpf = true
          this.label_loading_cpf = "Buscando dados do membro na CEMIG...";
          // console.log('busca CPF na Cemig')
          await getCPFCemig(cpf)
            .then((ret) => {
              // console.log('Status: ', ret.status)
              if (ret.status === 200) {
                // console.log('dados ucs: ', ret.data)
                this.ucs_cemig = ret.data;
                ret.data.forEach((data, idx) => {
                  const item_uc = {
                    text: data.installation_number,
                    color: this.colors[idx],
                  };
                  // this.ucs_cemig.push(item_uc)
                  this.items.push(item_uc);
                  // console.log('items: ', this.items)
                });
                this.dialog_ucs = true;
              } else {
                this.snack(
                  "Atenção: CPF não encontrado no site da CEMIG, validar se o CPF informado é do titular da conta.",
                  "warning",
                  "bottom",
                );
                this.dialog_cpf = false;
                this.valid = false;
              }
            })
            .catch((err) => {
              // this.dialog_ucs = true
              console.error(err);
              // this.snack('Erro ao buscar dados do membro na CEMIG. Valide os dados com o membro para continuar. ', 'warning', 'bottom')
              this.snack(
                "Atenção: CPF não encontrado no site da CEMIG, validar se o CPF informado é do titular da conta.",
                "warning",
                "bottom",
              );
            });
          this.label_loading_cpf = "Buscando dados complementares do membro...";
          getPEOPLE(cpf)
            .then((result) => {
              if (result.data.BasicData) {
                // console.log('BasicData: ', result.data.BasicData)
                ((this.nome_titular = result.data.BasicData.Name || ""),
                  (this.gender = result.data.BasicData.Gender || ""));
                this.nacionalidade =
                  result.data.BasicData.BirthCountry || "brasileiro(a)";
                this.mother_name = result.data.BasicData.MotherName || "";
                this.birthday = this.formatDate(
                  result.data.BasicData.BirthDate,
                );
              }
              if (
                result.data.ProfessionData &&
                result.data.ProfessionData.TotalProfessions > 0
              ) {
                // console.log('ProfessionData: ', result.data.ProfessionData)
                if (
                  result.data.ProfessionData.Professions &&
                  result.data.ProfessionData.Professions.length >= 0
                ) {
                  result.data.ProfessionData.Professions.forEach((t) => {
                    if (t.Level !== "UNKNOWN") {
                      this.profissao = t.Level;
                      return;
                    }
                  });
                  // if(result.data.ProfessionData.Professions[0].Level) {
                  // 	this.profissao = result.data.ProfessionData.Professions[0].Level==='UNKNOWN'?'':result.data.ProfessionData.Professions[0].Level || ''
                  // }
                }
              }
              // this.loading_cpf = false
              this.dialog_cpf = false;
            })
            .catch((error) => {
              // this.snack('CPF não encontrado na base de dados externa. Por favor, preencha os dados (Data nascimento, sexo, etc...) manualmente. Erro: ' + error, 'red', 'top')
              console.error(
                "CPF não encontrado na base de dados externa. Por favor, preencha os dados (Data nascimento, sexo, etc...) manualmente. Erro: " +
                  error,
              );
              // this.loading_cpf = false
              this.dialog_cpf = false;
            });
        } else {
          this.dialog_cpf = false;
        }
      }
    },
    ucs_selected() {
      // console.log('ucs_chbox: ', this.ucs_chbox)
      this.ucs_chbox.map((sel, index) => {
        const obj = {
          text: sel,
          color: this.colors[index],
        };
        this.ucs.push(obj);
      });
      this.dialog_ucs = false;

      if (this.$refs["rg"]) this.$refs["rg"].focus();
    },
    clearUser() {
      this.cadLead = "new";
      this.valid = false;
      this.user = {};
      this.lead = {};
      this.name = "";
      this.nome_titular = "";
      this.email = "";
      this.phone = "";
      this.average = "";
      this.cep = "";
      this.cpf = "";
      this.rg = "";
      this.birthday = "";
      this.gender = "";
      this.profissao = "";
      this.marital_type_value = "";
      this.marital_status_value = "";
      this.consumer_unit = "";
      this.installation_number = "";
      this.installation_numbers = [];
      this.mother_name = "";
      this.orgao_expeditor = "";
      this.cep = "";
      this.logradouro = "";
      this.numero = "";
      this.complemento = "";
      this.bairro = "";
      this.localidade = "";
      ((this.items = []), (this.ucs = []));
      ((this.ucs_chbox = []),
        (this.state = {
          initials: "MG",
          name: "Minas Gerais",
        }),
        (this.payment_type = ""));
    },
    snack(message, color, ...args) {
      this.top = false;
      this.bottom = false;
      this.left = false;
      this.right = false;

      for (const loc of args) {
        this[loc] = true;
      }

      this.color = color;
      this.snackMessage = message;
      this.snackbar = true;
    },
    formatDate(value) {
      if (!value || value === "") return "";
      if (new Date(value)) {
        return moment.utc(new Date(value)).format("DD/MM/YYYY");
      } else {
        return value;
      }
    },
    validaCPF(strCPF) {
      if (!strCPF) return "";
      var Soma;
      var Resto;
      Soma = 0;
      if (strCPF == "00000000000") return false;
      if (strCPF == "11111111111") return false;

      for (let i = 1; i <= 9; i++)
        Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
      Resto = (Soma * 10) % 11;

      if (Resto == 10 || Resto == 11) Resto = 0;
      if (Resto != parseInt(strCPF.substring(9, 10))) return false;

      Soma = 0;
      for (let i = 1; i <= 10; i++)
        Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
      Resto = (Soma * 10) % 11;

      if (Resto == 10 || Resto == 11) Resto = 0;
      if (Resto != parseInt(strCPF.substring(10, 11))) return false;
      // console.log('valida CPF: ', true)
      return true;
    },
    async validaCPFNaBase(cpf) {
      if (this.validaCPF(cpf)) {
        const ret = await firestore
          .collection("users")
          .where("cpf", "==", cpf)
          .limit(1)
          .get();
        if (ret.size > 0) {
          // console.log('e:', ret.docs[0].data().email)
          let msg =
            "CPF já cadastrado na base com o email " +
            ret.docs[0].data().email +
            ".";
          // console.log('a: ', ret.docs[0].data().signedcontract_at)
          if (ret.docs[0].data().signedcontract_at) {
            let dt_assin = moment(
              new Date(ret.docs[0].data().signedcontract_at),
            ).format("DD/MM/YYYY HH:mm");
            msg =
              msg +
              "<br>Cliente assinou o contrato em <b>" +
              dt_assin +
              "</b> por meio ";
            if (ret.docs[0].data().signedcontract_by === "SUPER") {
              msg =
                msg +
                "de <b>Callcenter</b> - Vendido por: <b>" +
                ret.docs[0].data().signedcontract_partner +
                "</b>";
            } else {
              msg = msg + "<b>Online</b>";
            }
            if (ret.docs[0].data().status) {
              msg =
                msg +
                "<br> Cliente com status: <b>" +
                ret.docs[0].data().status +
                "</b>";
            }
          }
          this.valid = false;
          // console.log('ref: ', this.$refs.form.validate())
          // this.snack('CPF já cadastrado na base com o email ' + ret.docs[0].data().email,'red','top')
          this.snack(msg, "red", "top");
          this.cpf_duplicated = true;
          this.cpf_duplicated_msg = msg;
          return true;
        } else {
          this.cpf_duplicated = false;
          this.cpf_duplicated_msg = "";
          return false;
        }
      } else {
        this.cpf_duplicated = false;
        this.cpf_duplicated_msg = "";
        return false;
      }
    },

    async validate() {
      if (this.$refs.form.validate()) {
        if (this.cadLead === "new" || this.old_cpf !== this.cpf) {
          if (await this.validaCPFNaBase(this.cpf)) {
            console.error("cpf já existe na base");
            return;
          }
        }
        // console.log('ucs size: ', this.ucs.length)
        // console.log('cadLead: ', this.cadLead)
        let status = "QUALIFICAR";
        let termo_uso = "Sim";
        if (this.loggedUser.send_proposal) {
          status = "REQUEST_PROPOSAL";
          termo_uso = "Não";
        }
        // console.log('form: ', this.$refs.form)
        this.loading = true;
        let newUser = {
          name: this.name,
          email: this.email.toLowerCase().trim() || this.email,
          phone: this.phone,
          group: "customer",
          address: {
            address: this.logradouro || "",
            address_number: this.numero || "",
            address_complement: this.complemento || "",
            district: this.bairro || "",
            postal_code: this.cep || "",
            state: this.state,
            city: this.localidade,
            country: {
              initials: "br",
              name: "Brasil",
            },
          },
          ID_document: this.rg + "-" + this.orgao_expeditor,
          average_consumption: this.average,
          cpf: this.cpf,
          password: this.cpf,
          date_of_birth: this.birthday,
          gender: this.gender,
          installation_number: this.consumer_unit,
          installation_numbers: this.ucs,
          nationality: this.nacionalidade || "brasileiro(a)",
          payment_type: this.payment_type,
          profession: this.profissao,
          mother_name: this.mother_name || "",
          requiredPSChange: 1,
          // signedcontract_at: new Date(),
          marital_status: this.marital_status_value,
          marital_type: this.marital_type_value,
          sales_observation: this.sales_observation || "",
          created_at: new Date(),
          updated_at: new Date(),
        };
        // Se Proposta
        if (this.loggedUser.send_proposal) {
          if (!this.user.customer_id) {
            newUser.status = status;
            newUser.termouso = termo_uso;
            newUser.sale_by = "SUPER";
            newUser.sale_source = this.loggedUser.partner_id;
            newUser.sale_partner = this.loggedUser.email;
          }
          //SE JÁ POSSUIA USUÁRIO E O MEIO DE PAGAMENTO ESTIVER MUDANDO, SETA A DATA DE ESCOLHA DO BOLETO
          // console.log('newUser: ', newUser)
          storeCustomer(newUser)
            .then((user) => {
              // console.log('u: ', user)
              if (user.status === 200 && user.data.buyer_id && user.data.id) {
                if (!this.user.customer_id) {
                  // console.log('usuario novo')
                  if (this.cadLead === "edit") {
                    const data = {
                      termouso: "Nao",
                    };
                    // console.log('atualiza lead: ', data)
                    updateLead(this.email, data)
                      .then(() => {
                        // console.log('Lead atualizado com sucesso')
                        return;
                      })
                      .catch((err) => {
                        console.error("Erro ao criar lead: ", err);
                      });
                  } else {
                    const data = {
                      ...newUser,
                      termouso: "Nao",
                    };
                    // console.log('atualiza lead: ', data)
                    addLead(data)
                      .then(() => {
                        // console.log('Lead criado com sucesso')
                        return;
                      })
                      .catch((err) => {
                        console.error("Erro ao criar lead: ", err);
                      });
                  }
                  if (this.ucs.length > 0) {
                    // console.log('Inicia Gravação de Analitycs')
                    this.ucs.map((uc) => {
                      const analytics = {
                        eventCategory: "SUPER",
                        eventAction: "SALE-PARTNER",
                        eventLabel: this.loggedUser.partner_id || "enercred",
                        transaction_id: user.data.email,
                        value: user.data.average_consumption,
                        utm_source: "SUPER",
                        utm_medium: "phone",
                        utm_campaign: this.loggedUser.email,
                        boleto: false,
                        uc: uc.text,
                      };
                      saveAnalytics(analytics);
                      // console.log('Adicionado analitycs: ' + analytics)
                    });
                  } else {
                    // console.log('Inicia Gravação de Analitycs')
                    const analytics = {
                      eventCategory: "SUPER",
                      eventAction: "SALE-PARTNER",
                      eventLabel: this.loggedUser.partner_id || "enercred",
                      transaction_id: user.data.email,
                      value: user.data.average_consumption,
                      utm_source: "SUPER",
                      utm_medium: "phone",
                      utm_campaign: this.loggedUser.email,
                      boleto: false,
                      uc: "não informado",
                    };
                    saveAnalytics(analytics);
                    // console.log('Adicionado analitycs: ' + analytics)
                  }

                  //Cadastra evento Offline no facebook
                  const valor = newUser.name.split(" ");
                  var nome = valor.shift();
                  var sobrenome = valor.join(" ");
                  let fb_data = {
                    email: newUser.email,
                    fn: nome || newUser.name,
                    ln: sobrenome || newUser.name,
                    phone: newUser.phone,
                    gen: newUser.gender,
                    extern_id: user.data.id,
                    lead_id: newUser.email,
                    value: newUser.average_consumption || 250,
                    currency: "BRL",
                  };
                  if (newUser.address && newUser.address.city)
                    fb_data.ct = newUser.address.city;
                  if (newUser.address && newUser.address.postal_code)
                    fb_data.zip = newUser.address.postal_code;

                  setFbEvent(fb_data, "inside_sale", "Purchase");
                }
                this.user = user.data;
                this.lead.user = user.data;
                eventBus.$emit("Lead", this.lead);
                this.snack("Venda realizada com sucesso!", "green", "top");
              } else {
                this.snack(
                  "Houve um erro inesperado. Procure nosso suporte!",
                  "red",
                  "top",
                );
              }
              this.loading = false;
            })
            .catch((error) => {
              console.error("Erro ao realizar venda!", error.message);
              let err_msg = "Erro ao realizar venda! Contate nosso suporte.";
              if (error.code === "auth/email-already-in-use") {
                err_msg = "Este email está sendo utilizado por outra conta.";
              }
              this.snack(err_msg, "red", "top");
              this.loading = false;
            });
        } else {
          // Se Venda
          if (!this.user.customer_id) {
            newUser.status = status;
            newUser.termouso = termo_uso;
            newUser.signedcontract_at = new Date();
            newUser.signedcontract_by = "SUPER";
            newUser.signedcontract_source = this.loggedUser.partner_id;
            newUser.signedcontract_partner = this.loggedUser.email;
          } else {
            if (!this.user.card_default && !this.user.boleto_accepted_at) {
              if (!newUser.signedcontract_at) {
                newUser.signedcontract_at = new Date();
                newUser.status = status;
                newUser.termouso = termo_uso;
              }
              newUser.signedcontract_by = "SUPER";
              newUser.signedcontract_source = this.loggedUser.partner_id;
              newUser.signedcontract_partner = this.loggedUser.email;
            }
          }
          // //SE JÁ POSSUIA USUÁRIO E O MEIO DE PAGAMENTO ESTIVER MUDANDO, SETA A DATA DE ESCOLHA DO BOLETO
          // if(this.user.customer_id && this.user.payment_type !== 'boleto' && this.payment_type === 'boleto') {
          // 	newUser.boleto_accepted_at = new Date(),
          // 	newUser.boleto_accepted_by = 'telefone'

          // //SE NÃO POSSUI USUARIO E A SELECAO É BOLETO
          // } else if(!this.user.customer_id && this.payment_type === 'boleto') {
          // 	newUser.boleto_accepted_at = new Date(),
          // 	newUser.boleto_accepted_by = 'telefone'
          // }
          // let historys = []
          if (!this.user.customer_id) {
            const history = {
              created_at: new Date(),
              user_id: this.loggedUser.email,
              action: "created",
            };
            newUser.history = [];
            newUser.history.push(history);
          } else {
            newUser.history = this.user.history || [];
            const history = {
              created_at: new Date(),
              user_id: this.loggedUser.email,
              action: "updated",
            };
            newUser.history.push(history);
          }
          // console.log('newUser: ', newUser)
          storeCustomer(newUser)
            .then((user) => {
              // console.log('u: ', user)
              if (user.status === 200 && user.data.buyer_id && user.data.id) {
                if (!this.user.customer_id) {
                  // console.log('usuario novo')
                  if (this.cadLead === "edit") {
                    // console.log('atualiza lead: ', newUser)
                    const data = {
                      signedcontract_at: new Date(),
                      signedcontract_by: "phone",
                      termouso: "Sim",
                      signedcontract_source: this.loggedUser.partner_id,
                      signedcontract_partner: this.loggedUser.email,
                    };
                    // console.log('atualiza lead: ', data)
                    updateLead(this.email, data)
                      .then(() => {
                        // console.log('Lead atualizado com sucesso')
                        return;
                      })
                      .catch((err) => {
                        console.error("Erro ao criar lead: ", err);
                      });
                  } else {
                    // console.log('cria lead: ', newUser)
                    addLead(newUser)
                      .then(() => {
                        // console.log('Lead criado com sucesso: ', resLead)
                        return;
                      })
                      .catch((err) => {
                        console.error("Erro ao criar lead: ", err);
                      });
                  }
                  if (this.ucs.length > 0) {
                    // console.log('Inicia Gravação de Analitycs')
                    this.ucs.map((uc) => {
                      const analytics = {
                        eventCategory: "SUPER",
                        eventAction: "SIGN-CONTRACT",
                        eventLabel: this.loggedUser.partner_id || "enercred",
                        transaction_id: user.data.email,
                        value: user.data.average_consumption,
                        utm_source: "SUPER",
                        utm_medium: "phone",
                        utm_campaign: this.loggedUser.email,
                        boleto: true,
                        uc: uc.text,
                      };
                      saveAnalytics(analytics);
                    });
                  } else {
                    // console.log('Inicia Gravação de Analitycs')
                    const analytics = {
                      eventCategory: "SUPER",
                      eventAction: "SIGN-CONTRACT",
                      eventLabel: this.loggedUser.partner_id || "enercred",
                      transaction_id: user.data.email,
                      value: user.data.average_consumption,
                      utm_source: "SUPER",
                      utm_medium: "phone",
                      utm_campaign: this.loggedUser.email,
                      boleto: true,
                      uc: "não informado",
                    };
                    saveAnalytics(analytics);
                    // console.log('Adicionado analitycs: ' + analytics)
                  }
                } else {
                  // console.log('usuario já existia')
                  if (newUser.signedcontract_at) {
                    if (this.ucs.length > 0) {
                      // console.log('Inicia Gravação de Analitycs')
                      this.ucs.map((uc) => {
                        const analytics = {
                          eventCategory: "SUPER",
                          eventAction: "SIGN-CONTRACT",
                          eventLabel: this.loggedUser.partner_id || "enercred",
                          transaction_id: user.data.email,
                          value: user.data.average_consumption,
                          utm_source: "SUPER",
                          utm_medium: "phone",
                          utm_campaign: this.loggedUser.email,
                          boleto: true,
                          uc: uc.text,
                        };
                        saveAnalytics(analytics);
                        // console.log('Adicionado analitycs: ' + analytics)
                      });
                    } else {
                      // console.log('Inicia Gravação de Analitycs')
                      const analytics = {
                        eventCategory: "SUPER",
                        eventAction: "SIGN-CONTRACT",
                        eventLabel: this.loggedUser.partner_id || "enercred",
                        transaction_id: user.data.email,
                        value: user.data.average_consumption,
                        utm_source: "SUPER",
                        utm_medium: "phone",
                        utm_campaign: this.loggedUser.email,
                        boleto: true,
                        uc: "não informado",
                      };
                      saveAnalytics(analytics);
                      // console.log('Adicionado analitycs: ' + analytics)
                    }
                  }
                }
                this.user = user.data;
                this.lead.user = user.data;
                eventBus.$emit("Lead", this.lead);

                let conversion = {
                  event_type: "SALE",
                  event_family: "CDP",
                  payload: {
                    email: user.data.email,
                    funnel_name: "default",
                    value: 200,
                  },
                };

                if (conversion.event_type) {
                  this.$apollo.mutate({
                    // Query
                    mutation: SET_CONVERSION,
                    // Parameters
                    variables: {
                      event_type: conversion.event_type,
                      event_family: conversion.event_family,
                      payload: conversion.payload,
                    },
                  });
                }

                //Cadastra evento Offline no facebook
                const valor = newUser.name.split(" ");
                var nome = valor.shift();
                var sobrenome = valor.join(" ");
                let fb_data = {
                  email: newUser.email,
                  fn: nome || newUser.name,
                  ln: sobrenome || newUser.name,
                  phone: newUser.phone,
                  gen: newUser.gender,
                  extern_id: user.data.id,
                  lead_id: newUser.email,
                  value: newUser.average_consumption || 250,
                  currency: "BRL",
                  customer_id: user.data.id,
                };
                if (newUser.address && newUser.address.city)
                  fb_data.ct = newUser.address.city;
                if (newUser.address && newUser.address.postal_code)
                  fb_data.zip = newUser.address.postal_code;

                setFbEvent(fb_data, "inside_sale", "Purchase");
                this.snack("Vendas realizada com sucesso!", "green", "top");
              } else {
                this.snack(
                  "Houve um erro inesperado. Procure nosso suporte!",
                  "red",
                  "top",
                );
              }
              this.loading = false;
            })
            .catch((error) => {
              console.error("Erro ao realizar venda!", error.message);
              let err_msg = "Erro ao gravar membro! Contate nosso suporte.";
              if (error.code === "auth/email-already-in-use") {
                err_msg = "Este email está sendo utilizado por outra conta.";
              }
              this.snack(err_msg + " - " + error, "red", "top");
              this.loading = false;
            });
        }
      }
    },
    async save() {
      if (!this.name || this.name.trim() === "") {
        this.snack("Por favor preencha o nome do membro!", "red", "top");
        return;
      }
      if (!this.email || this.email.trim() === "") {
        this.snack("Por favor preencha o email do membro!", "red", "top");
        return;
      }
      if (!this.phone || this.phone.trim() === "") {
        this.snack("Por favor preencha o telefone do membro!", "red", "top");
        return;
      }
      if (!this.cpf || this.cpf.trim() === "") {
        this.snack("Por favor preencha o CPF do membro!", "red", "top");
        return;
      }
      if (!this.birthday || this.birthday.trim() === "") {
        this.snack(
          "Por favor preencha a DATA DE NASCIMENTO do membro!",
          "red",
          "top",
        );
        return;
      }
      if (!this.gender || this.gender.trim() === "") {
        this.snack("Por favor preencha o SEXO do membro!", "red", "top");
        return;
      }
      if (!this.cep || this.cep.trim() === "") {
        this.snack("Por favor preencha o CEP do membro!", "red", "top");
        return;
      }
      if (!this.sales_observation || this.sales_observation.trim() === "") {
        this.snack(
          "Por favor preencha um observação do motivo de salvar esse Lead!",
          "red",
          "top",
        );
        return;
      }
      // if (!this.email || this.email.trim() === '' || !this.name || this.name.trim() === '' ||
      // 	!this.phone || this.phone.trim() === '' || !this.cpf || this.cpf.trim() === '' ||
      // 	!this.cep || this.cep.trim() === '' || !this.date_of_birth || this.date_of_birth.trim() === '') {
      if (this.cadLead === "new" || this.old_cpf !== this.cpf) {
        if (await this.validaCPFNaBase(this.cpf)) {
          console.error("cpf já existe na base");
          return;
        }
      }
      // console.log('ucs size: ', this.ucs.length)
      // console.log('cadLead: ', this.cadLead)
      let status = "SAVED";
      // let termo_uso = "Nào"
      // console.log('form: ', this.$refs.form)
      this.loading = true;
      let newUser = {
        name: this.name,
        email: this.email.toLowerCase().trim() || this.email,
        phone: this.phone,
        group: "customer",
        address: {
          address: this.logradouro || "",
          address_number: this.numero || "",
          address_complement: this.complemento || "",
          district: this.bairro || "",
          postal_code: this.cep || "",
          state: this.state,
          city: this.localidade,
          country: {
            initials: "br",
            name: "Brasil",
          },
        },
        ID_document: this.rg + "-" + this.orgao_expeditor,
        average_consumption: this.average,
        cpf: this.cpf,
        password: this.cpf,
        date_of_birth: this.birthday,
        gender: this.gender,
        installation_number: this.consumer_unit,
        installation_numbers: this.ucs,
        nationality: this.nacionalidade || "brasileiro(a)",
        payment_type: this.payment_type,
        profession: this.profissao,
        mother_name: this.mother_name || "",
        requiredPSChange: 1,
        // signedcontract_at: new Date(),
        marital_status: this.marital_status_value,
        marital_type: this.marital_type_value,
        sales_observation: this.sales_observation,
        updated_at: new Date(),
      };

      // Salvar
      if (!this.user.customer_id) {
        newUser.status = status;
        // newUser.termouso = termo_uso
        newUser.saved_at = new Date();
        newUser.saved_by = "SUPER";
        newUser.saved_source = this.loggedUser.partner_id;
        newUser.saved_partner = this.loggedUser.email;
      } else {
        let msg = "Usuario já está cadastrado e não pode ser salvo";
        // console.log('a: ', ret.docs[0].data().signedcontract_at)
        this.valid = false;
        // console.log('ref: ', this.$refs.form.validate())
        // this.snack('CPF já cadastrado na base com o email ' + ret.docs[0].data().email,'red','top')
        this.snack(msg, "red", "top");
      }
      // console.log('newUser: ', newUser)
      //Salva lead
      if (this.cadLead === "edit") {
        const newLead = {
          ...this.lead,
          user: newLead,
        };
        updateLead(this.email, newLead)
          .then(() => {
            // console.log('Lead atualizado com sucesso')
            this.snack("Lead gravado com sucesso!", "green", "top");
            this.loading = false;
          })
          .catch((err) => {
            this.snack(
              "Houve um erro inesperado. Procure nosso suporte!",
              "red",
              "top",
            );
            console.error("Erro ao criar lead: ", err);
            this.loading = false;
          });
      } else {
        const newLead = {
          name: this.name,
          email: this.email.toLowerCase().trim() || this.email,
          phone: this.phone,
          group: "customer",
          user: newLead,
        };
        // console.log('cria lead: ', newUser)
        addLead(newUser)
          .then(() => {
            // console.log('Lead criado com sucesso: ', resLead)
            this.snack("Lead gravado com sucesso!", "green", "top");
            this.loading = false;
          })
          .catch((err) => {
            this.snack(
              "Houve um erro inesperado. Procure nosso suporte!",
              "red",
              "top",
            );
            console.error("Erro ao criar lead: ", err);
            this.loading = false;
          });
      }
    },
    reverseDate(date) {
      if (!date || date === "") return "";
      // console.log('dd: ', typeof(date))
      // console.log('dd: ', date)
      if (typeof date !== "string") {
        // console.log('date1: ', new Date(date))
        return moment.utc(new Date(date)).format("DD/MM/YYYY");
      } else {
        let ano = date.split("/")[2];
        let _ano = date.split("-")[0];

        if (_ano && _ano.length <= 4) {
          // console.log('_ano: ', _ano.length)
          // console.log('split: ', date.split('-'))
          let dia = "";
          if (date.split("-")[2]) {
            dia = date.split("-")[2].substring(0, 2);
          }
          let mes = date.split("-")[1];
          return dia + mes + _ano;
        } else if (ano && ano.length <= 4) {
          // console.log('ano: ', ano.length)
          let dia = "";
          if (date.split("/")[0]) {
            dia = date.split("/")[0].substring(0, 2);
          }
          let mes = date.split("/")[1];
          return dia + mes + ano;
        }

        // console.log('date2: ', date)
        return date;
      }
    },
  },
};
</script>
